import React, { Component } from 'react';
import { store } from 'Store/store.index';
import { Modal } from 'antd';
import utils from "@foxit/utils";
import './fwConvertModal.scss';
export default class fwConvertModal extends Component {
  constructor(props) {
    super(props);
    this.convertUpload = this.convertUpload.bind(this);
    this.init = this.init.bind(this);
    this.downFile = this.downFile.bind(this);
    this.getToPdfTaskName = this.getToPdfTaskName.bind(this);
    this.convertChangeResult = this.convertChangeResult.bind(this);
    this.convertPdfFileType = store.convert.convertPdfFileName.split('.')[store.convert.convertPdfFileName.split('.').length-1];
    this.downloadUrl = '';
    this.state = {
      convertState: "success",
      convertPdfFileName: store.convert.convertPdfFileName,
      convertAfterFileName:""
    }
    this.taskNameArr = {
      "convert-pdf-to-word":"PDF2WORD",
      "convert-pdf-to-excel":"PDF2Excel",
      "convert-pdf-to-ppt":"PDF2PPT",
      "convert-pdf-to-png":"PDF2PNG",
      "convert-pdf-to-jpg":"PDF2JPG",
      "convert-pdf-to-longPng":"PDF2LONGPNG",
      "export-all-img":"PDFEXPORTIMAGE",
      "convert-word-to-pdf":"WORD2PDF",
      "convert-excel-to-pdf":"EXCEL2PDF",
      "convert-ppt-to-pdf":"POWERPOINT2PDF",
      "convert-img-to-pdf":"IMAGE2PDF",
      "ocr-pdf-to-pdf": "OCRPDF2PDF"
    }
  }
  componentDidMount () {
    this.init();
  }
  componentWillUnmount() {}
  /**
   * [init 初始化]
   *
   * @return  {[type]}  [return description]
   */
  init(){
    this.setState({
      convertState: "pending"
    })
    if(store.convert.convertType === "convert-to-pdf" && !store.convert.toPdfConvertOpenFile){
      const fileUrl = store.convert.convertUrlFile;
      this.getToPdfTaskName();
      this.setState({
        convertAfterFileName:this.state.convertPdfFileName
      })
      utils.util.urlToBlob(fileUrl).then(async (blob) =>{
        this.convertUpload(store.convert.postConvertUpload(blob, this.state.convertPdfFileName))
      })
    } else if(store.convert.toPdfConvertOpenFile && store.convert.convertType === "convert-to-pdf") {
      // 載入文檔直接轉換
      this.getToPdfTaskName();
      this.setState({
        convertAfterFileName:this.state.convertPdfFileName
      })
      this.convertUpload(store.convert.postConvertUpload(store.convert.convertOpenFile, this.state.convertPdfFileName))
    } else {
      this.setState({
        convertAfterFileName:store.docStore.docInfo.fileName
      })
      this.convertUpload(store.convert.fileToBlob(store.docStore.docInfo.fileName));
    }
  }
  /**
   * [getToPdfTaskName 获取转换pdf文件类型]
   *
   * @return  {[type]}  [return description]
   */
  getToPdfTaskName(){
    if(this.convertPdfFileType === "doc" || this.convertPdfFileType === "docx"){
      store.convert.getConvertType("convert-word-to-pdf")
    } else if(this.convertPdfFileType === "xls" || this.convertPdfFileType === "xlsx"){
      store.convert.getConvertType("convert-excel-to-pdf")
    } else if(this.convertPdfFileType === "ppt" || this.convertPdfFileType === "pptx"){
      store.convert.getConvertType("convert-ppt-to-pdf")
    } else {
      store.convert.getConvertType("convert-img-to-pdf")
    }
  }
  /**
   * [convertUpload 上传转换文件]
   *
   * @return  {[type]}  [return description]
   */
  convertUpload(func){
    let docId, taskName;
    func.then(res=>{
      if(res.code === 0){
        docId = res.data.docId;
        taskName = this.taskNameArr[store.convert.convertType]
        this.convertTask(docId, taskName)
      }
    },()=>{
      this.setState({
        convertState: "error"
      })
    })
  }
  /**
   * [convertTask 文件转换]
   *
   * @param   {[type]}  docId     [docId 文档id]
   * @param   {[type]}  taskName  [taskName 转换类型名称]
   *
   * @return  {[type]}            [return description]
   */
  async convertTask(docId, taskName){
    try {
      const convertTaskRes = await store.convert.postConvertTask(docId, taskName);
      if(convertTaskRes.code === 0){
        this.convertChangeResult(convertTaskRes.data.docId, convertTaskRes.data.taskId);
      } else {
        this.setState({
          convertState: "error"
        })
      }
    } catch (error) {
      this.setState({
        convertState: "error"
      })
    }
  }
  /**
   * [downFile 下载文件]
   *
   * @return  {[type]}  [return description]
   */
  downFile(){
    window.open(this.downloadUrl);
  }
  /**
   * [convertChangeResult 查询转换进度]
   *
   * @param   {[type]}  docId   [docId 文档id]
   * @param   {[type]}  taskId  [taskId 任务id]
   *
   * @return  {[type]}          [return description]
   */
  convertChangeResult(docId, taskId){
    store.convert.getConvertChangeResult(docId, taskId).then(res=>{
      if(res.code === 0){
        if(res.data.taskState === 'FINISH'){
          this.setState({
            convertState: "success"
          })
          this.downloadUrl = res.data.downloadUrl + "&token=" + store.userNewStore.userToken;
          if(store.convert.toPdfConvertOpenFile) {
            // 如果为打开文件直接转换，则完成后直接打开文件
            store.convert.getToPdfConvertOpenFile(false)
            this.props.openUrl(this.downloadUrl, res.data.fileName)
            this.closeModal()
            // store.viewer.doOpenFile(this.downloadUrl, (isLoading)=>{
            //   isLoading && store.appStore.doShowEditorLoading();
            // })
          }
        } else {
          if(store.convert.isShowFwConvertModal){
            setTimeout(() => {
              this.convertChangeResult(docId, taskId)
            }, 3000);
          }
        }
      } else {
        this.setState({
          convertState: "error"
        })
      }
    },()=>{
      this.setState({
        convertState: "error"
      })
    })
  }
  /**
   * [closeModal 关闭弹框]
   *
   * @return  {[type]}  [return description]
   */
  closeModal() {
    store.convert.getIsShowFwConvertModal(false); 
    store.common.axiosPromiseCancel(store.common.axiosPromiseList);
  }
  render() {
    let convertToDOM = <img src={require('@/assets/fwConvert/pdf.png')}/>;
    let convertText;
    let convertFromDOM = <img src={require('@/assets/fwConvert/pdf.png')}/>;
    let convertType = store.convert.convertType;
    let mainDOM;
    let { convertState, convertAfterFileName } = this.state;
    let convertSuccessFileType;
    if(convertType === "convert-pdf-to-word"){
      convertToDOM = <img src={require('@/assets/fwConvert/word.png')}/>
      convertText = "正在将文件转为Word";
      convertSuccessFileType = "已成功转为Word格式";
    } else if(convertType === "convert-pdf-to-excel"){
      convertToDOM = <img src={require('@/assets/fwConvert/excel.png')}/>
      convertText = "正在将文件转为Excel";
      convertSuccessFileType = "已成功转为Excel格式";
    } else if(convertType === "convert-pdf-to-ppt"){
      convertToDOM = <img src={require('@/assets/fwConvert/ppt.png')}/>
      convertText = "正在将文件转为PPT";
      convertSuccessFileType = "已成功转为PPT格式";
    } else if(convertType === "convert-pdf-to-png" || convertType === "convert-pdf-to-jpg" || convertType === "convert-pdf-to-longPng"){
      convertToDOM = <img src={require('@/assets/fwConvert/picture.png')}/>
      convertText = "正在将文件转为图片";
      convertSuccessFileType = "已成功转为图片格式";
    } else if(convertType === "export-all-img"){
      convertToDOM = <img src={require('@/assets/fwConvert/picture.png')}/>
      convertText = "正在导出图像";
      convertSuccessFileType = "已成功导出图像";
    } else if(convertType === "ocr-pdf-to-pdf"){
      convertToDOM = <img src={require('@/assets/fwConvert/ppt.png')}/>
      convertText = "正在对文件进行识别";
      convertSuccessFileType = "已成功文件识别";
    } else {
      convertText = "正在将文件转为PDF";
      convertSuccessFileType = "已成功转为PDF格式";
      switch (this.convertPdfFileType) {
        case "jpg":
        case "png":
        case "bmp":
        case "jpeg":
        case "tif":
        case "gif":
        case "jpe":
          convertFromDOM = <img src={require('@/assets/fwConvert/picture.png')}/>
          convertToDOM = <img src={require('@/assets/fwConvert/pdf.png')}/>
          break;
        case "ppt":
        case "pptx":
          convertFromDOM = <img src={require('@/assets/fwConvert/ppt.png')}/>
          convertToDOM = <img src={require('@/assets/fwConvert/pdf.png')}/>
          break;
        case "docx":
        case "doc":
          convertFromDOM = <img src={require('@/assets/fwConvert/word.png')}/>
          convertToDOM = <img src={require('@/assets/fwConvert/pdf.png')}/>
          break;
        case "xlsx":
        case "xls":
          convertFromDOM = <img src={require('@/assets/fwConvert/excel.png')}/>
          convertToDOM = <img src={require('@/assets/fwConvert/pdf.png')}/>
          break;
        default:
          break;
      }
    }
    if(convertState === "pending"){
      mainDOM = <div className='main'>
        <div className='convertLoading'>
          {convertFromDOM}
          <img className='icon' src={require('@/assets/fwConvert/changeLoading.gif')}/>
          {convertToDOM}
        </div>
        <div className='text'>
          {convertText}
        </div>
        {/* <div className='down'>
          <span>不想等待？</span>
          <a href="https://editor.foxitsoftware.cn/?from=editcloud" target="_blank" rel="noopener noreferrer">点此下载客户端，享受超快转换</a>
        </div> */}
                </div>
    } else if(convertState === "success") {
      mainDOM = <div className='main'>
                  <div className='title'>
                    <img src={require('@/assets/fwConvert/changeSuccess.png')} alt='icon' />
                    <span>转换成功</span>
                  </div>
                  <div className='content'>
                    <p>“<span>{convertAfterFileName}</span>”</p>
                    <p>{convertSuccessFileType}</p>
                  </div>
                  <div className='convertFooter'>
                    <button className='again' onClick={this.downFile}>
                      <img src={require('@/assets/fwConvert/changeUpload.png')} alt='icon' />
                      下载文件
                    </button>
                  </div>
                </div>
    } else {
      mainDOM = <div className='main'>
                  <div className='title'>
                    <img src={require('@/assets/fwConvert/changeErr.png')} alt='icon' />
                    <span>转换失败</span>
                  </div>
                  <div className='content'>
                    <p>“<span>{convertAfterFileName}</span>”</p>
                    <p>转换失败</p>
                  </div>
                  <div className='convertFooter'>
                    <button className='again' onClick={this.init}>
                      <img src={require('@/assets/fwConvert/changeAgain.png')} alt='icon' />
                      重新转换
                    </button>
                    <button className='cancel' onClick={this.closeModal}>取消转换</button>
                  </div>
                </div>
    }
    return (
      <React.Fragment>
        <Modal
          title=''
          visible={true} 
          onCancel={this.closeModal}
          footer={null} 
          width="446px"
          height="260px" className="fwConvertModal">
            {mainDOM}
        </Modal>
      </React.Fragment>
    );
  }
}
